const getters = {
  visitedViews: state => state.app.visitedViews,

  loginName: state => state.user.loginName,
  nickname: state => state.user.nickname,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  role: state => state.user.role,
  menus: state => state.permission.menus,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  dicts: state => state.dictData.dicts,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js